export default objects => {return { left: objects[0]?.offsetLeft, top: objects[0]?.offsetTop }}
